import React from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import {
  Button,
  FieldDatePicker,
  ValidationError,
  CircularProgressLoader,
  AccessControl,
  PERMISSION_KEYS,
  PERMISSION_TYPES,
  FieldSearchBar,
} from '../../components';
import {
  FormattedMessage,
  injectIntl,
} from '../../utils/reactIntl';
import carretDown from '../../assets/svg/caretdown.svg';
import exp from '../../assets/svg/export.svg';
import ClearIcon from '@material-ui/icons/Clear';
import '../../components/LayoutWrapperMain/LayoutWrapperMain.global.scss';
import searchBarApis from '../../utils/searchBarApis';

interface Props {
  handleFormSubmit: any,
  handleResetSorts: any,
  handleExport: any,
  loaderExport: any,
  intl: any,
  error: any,
}

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

const ReportedUserManagementFilter: React.FC<Props> = (props: Props) => {
  const {
    handleFormSubmit,
    handleResetSorts,
    intl,
    error,
    handleExport,
    loaderExport,
  } = props;
  const formProps = useForm();
  const [showFilter, setShowFilter] = React.useState(true);
  const [toggle, setToggle] = React.useState(false);
  const handleReset = () => {
    formProps.reset({
      search: '',
      startDate: null,
      endDate: null,
      userType: '',
    });
    handleResetSorts();
  };
  return (
    <form
      className="filterForm"
      onSubmit={formProps.handleSubmit(handleFormSubmit)}
    >
      <div className="filter_container">
        <div className="filterSearch">
          <div>
            <div className="filter">
              Filter
              <span
                className="closeBtn"
                role="presentation"
                onClick={() => setTimeout(() => {
                  setShowFilter((prevState) => !prevState);
                }, 200)}
              >
                {showFilter
                  ? (
                    <ClearIcon />
                  ) : <img src={carretDown} alt="down" />}
              </span>
            </div>
            <div className="fieldSet">
              <FieldSearchBar
                searchURL={searchBarApis.userManagement}
                formProps={formProps}
                name="search"
                label={intl.formatMessage({ id: 'ReportedUserManagement.search.label' })}
                id="search"
              />
            </div>
          </div>
          <AccessControl
            permissionKey={PERMISSION_KEYS.REPORT_USER_MANAGEMENT}
            accessType={PERMISSION_TYPES.EDIT}
          >
            <div className="userRightExport">
              {!loaderExport
                ? (
                  <>
                    <span>
                      <img
                        src={exp}
                        alt="export"
                        role="presentation"
                        onClick={() => setToggle((prevState: boolean) => !prevState)}
                      />
                    </span>
                    {toggle && (
                      <ul className="userrigthToggle">
                        <li
                          role="presentation"
                          onClick={() => handleExport('XLSX')}
                        >
                          {intl.formatMessage({ id: 'ReportedUserManagement.label.expot.xlsx' })}
                        </li>
                        <li
                          role="presentation"
                          onClick={() => handleExport('CSV')}
                        >
                          {intl.formatMessage({ id: 'ReportedUserManagement.label.export.csv' })}
                        </li>
                      </ul>
                    )}
                  </>
                ) : <div className="exportProgressBar"><CircularProgressLoader /></div>}
            </div>
          </AccessControl>
        </div>
        {showFilter && (
          <div>
            <p>
              Added on
            </p>
            <div className="filterOptions">
              <div className="datepickerField">
                <FieldDatePicker
                  id="startDate"
                  name="startDate"
                  label={intl.formatMessage({ id: 'ReportedUserManagement.startDate.label' })}
                  formProps={formProps}
                  maxDate={formProps.watch('endDate') !== null ? formProps.watch('endDate') : moment().subtract(0, 'years').format('YYYY-MM-DD')}
                />
              </div>
              <div className="datepickerField">
                <FieldDatePicker
                  id="endDate"
                  name="endDate"
                  label={intl.formatMessage({ id: 'ReportedUserManagement.endDate.label' })}
                  formProps={formProps}
                  minDate={formProps.watch('startDate') !== null ? formProps.watch('startDate') : moment().subtract(118, 'years').format('YYYY-MM-DD')}
                />
              </div>
              <div className="buttonWrapper">
                <Button buttonType={ButtonTypes.submit} className="button">
                  <FormattedMessage id="ReportedUserManagement.apply.label" />
                </Button>
                <Button onClick={handleReset} className="button">
                  <FormattedMessage id="ReportedUserManagement.reset.label" />
                </Button>
              </div>
            </div>
            <ValidationError error={error} />
          </div>
        )}
      </div>
    </form>
  );
};

export default injectIntl(ReportedUserManagementFilter);
